var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo, useEffect, useCallback } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import clsx from 'clsx';
import { useForm, useFormRefs, useFieldProps } from '../hooks';
import { throttleFetch } from '../functions';
import FormInput, { useFormInputStyles } from './FormInput';
import FormHelperText from './FormHelperText';
var fetch = throttleFetch(200);
function FormAutocomplete(_a) {
    var _this = this;
    var description = _a.description, isLoading = _a.isLoading, defaultValue = _a.defaultValue, initialValue = _a.initialValue, id = _a.id, fetchOnEmpty = _a.fetchOnEmpty, fetchFunction = _a.fetchFunction, setDefaultValue = _a.setDefaultValue, onChangeOptionsFilter = _a.onChangeOptionsFilter, _b = _a.valueForForm, valueForForm = _b === void 0 ? function (value) { return value; } : _b, _c = _a.classes, _d = _c === void 0 ? {} : _c, container = _d.container, labelContainer = _d.labelContainer, label = _d.label, errorContainer = _d.errorContainer, inputContainer = _d.inputContainer, autocompleteContainer = _d.autocompleteContainer, inputClasses = __rest(_d, ["container", "labelContainer", "label", "errorContainer", "inputContainer", "autocompleteContainer"]), autocompleteClasses = _a.autocompleteClasses, rest = __rest(_a, ["description", "isLoading", "defaultValue", "initialValue", "id", "fetchOnEmpty", "fetchFunction", "setDefaultValue", "onChangeOptionsFilter", "valueForForm", "classes", "autocompleteClasses"]);
    var _e = useState(initialValue || null), valueNoDefault = _e[0], setValueNoDefault = _e[1];
    var _f = useState([]), selectOptions = _f[0], setSelectOptions = _f[1];
    var _g = useState(initialValue && valueForForm(initialValue) || null), selectedOption = _g[0], setSelectedOption = _g[1];
    var _h = useState(''), inputValue = _h[0], setInputValue = _h[1];
    var formInputClasses = useFormInputStyles();
    var form = useForm();
    var innerRef = useFormRefs();
    var inputProps = useFieldProps(id);
    var value = useMemo(function () { return defaultValue ? defaultValue : valueNoDefault; }, [defaultValue, valueNoDefault]);
    var setValue = useMemo(function () { return setDefaultValue ? setDefaultValue : setValueNoDefault; }, [setDefaultValue, setValueNoDefault]);
    var error = useMemo(function () {
        var isFieldTouched = form.touched[id];
        var fieldValue = form.values[id];
        return ((isFieldTouched && (!fieldValue || (isFieldTouched && selectedOption !== fieldValue)))
            ?
                form.errors[id]
            : null);
    }, [form, selectedOption, id]);
    var onFocusFetch = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var newOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchFunction(inputValue)];
                case 1:
                    newOptions = _a.sent();
                    if (selectOptions.length)
                        return [2 /*return*/];
                    setSelectOptions(newOptions);
                    return [2 /*return*/];
            }
        });
    }); }, [fetchFunction, selectOptions, inputValue]);
    var onChange = useCallback(function (_event, newValue) {
        if (!newValue)
            return;
        setValue(newValue);
        onChangeOptionsFilter ? setSelectOptions(function (options) { return onChangeOptionsFilter(newValue, options); }) : setSelectOptions(function (options) { return __spreadArray([newValue], options); });
        setSelectedOption(valueForForm(newValue));
        form.setFieldValue(id, valueForForm(newValue));
    }, [setValue, setSelectOptions, setSelectedOption, valueForForm, form, id]);
    var onBlur = useCallback(function () {
        setSelectOptions([]);
        setInputValue('');
        form.setFieldValue(id, value ? valueForForm(value) : "");
    }, [value, setSelectOptions, setInputValue, valueForForm, form, id]);
    var onInputChange = useCallback(function (event, newInputValue) {
        if (!event)
            return;
        if (event.type === "click" || event.type === "onKeyDown")
            return (setInputValue(''), setValue(null), form.setFieldValue(id, ''));
        if (event.type === 'blur')
            return setInputValue('');
        setInputValue(newInputValue);
    }, [setInputValue, setValue, form, id]);
    useEffect(function () {
        var active = true;
        if (isLoading || (!inputValue && !fetchOnEmpty))
            return;
        fetch(inputValue, function (inputValue) { return __awaiter(_this, void 0, void 0, function () {
            var newOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchFunction(inputValue)];
                    case 1:
                        newOptions = _a.sent();
                        if (!active)
                            return [2 /*return*/];
                        setSelectOptions(newOptions);
                        return [2 /*return*/];
                }
            });
        }); });
        return function () {
            active = false;
        };
    }, [inputValue, value, isLoading, fetchFunction]);
    if (isLoading)
        return _jsx(FormInput, { id: id, description: description, loading: true }, void 0);
    return (_jsx(Autocomplete, __assign({ autoComplete: true, value: value, handleHomeEndKeys: true, id: id, includeInputInList: true, options: selectOptions, filterOptions: function (x) { return x; }, innerRef: function () { return innerRef; }, className: autocompleteContainer, onChange: onChange, onInputChange: onInputChange, classes: autocompleteClasses, renderInput: function (params) { return (_jsxs("div", __assign({ onBlur: inputProps.onBlur, ref: params.InputProps.ref, className: container }, { children: [_jsx("div", __assign({ className: clsx(formInputClasses.containLables, labelContainer) }, { children: _jsx(InputLabel, __assign({}, params.InputLabelProps, { className: clsx(formInputClasses.label, label) }, { children: description }), void 0) }), void 0),
                _jsx("div", __assign({ onFocus: onFocusFetch, onBlur: onBlur, className: inputContainer }, { children: _jsx(Input, __assign({ type: "text", autoComplete: "off", disableUnderline: true, inputRef: function (el) { if (el && innerRef)
                            innerRef.current[id] = el; }, inputProps: __assign(__assign({}, params.inputProps), { form: { autocomplete: rest.autoComplete === false ? 'off' : undefined } }), classes: inputClasses }, params.InputProps, inputProps, { className: clsx(formInputClasses.input, error && formInputClasses.border) }), void 0) }), void 0),
                _jsx(FormHelperText, { className: errorContainer, text: error, error: true }, void 0)] }), void 0)); } }, rest), void 0));
}
;
export default FormAutocomplete;
//# sourceMappingURL=FormAutocomplete.js.map